module.exports = __webpack_public_path__ + "static/img/star-big.2fdabc20.png";